var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgThorLogo = function SvgThorLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 46"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#thor-logo_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#thor-logo_svg__b)",
    d: "m-.001 45.781.142.22 32.031-13.295c-.176-.31-.226-.462-.327-.565-3.101-3.12-6.212-6.232-9.307-9.357-.444-.447-.787-.362-1.167.057a347 347 0 0 1-2.957 3.208c-5.438 5.808-10.88 11.609-16.318 17.416-.712.76-1.396 1.542-2.093 2.314zm40-45.545-.176-.237c-.306.118-.615.23-.916.353q-7.173 2.952-14.344 5.912c-4.03 1.664-8.053 3.343-12.089 4.99-.72.295-.77.612-.24 1.128.757.735 1.501 1.48 2.247 2.225 2.237 2.233 4.476 4.466 6.708 6.707.526.53.93.558 1.43-.085.814-1.05 1.733-2.02 2.583-3.044q6.705-8.07 13.395-16.149c.486-.585.937-1.2 1.404-1.8z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "thor-logo_svg__b",
    x1: 36.52,
    x2: 4.573,
    y1: -1.221,
    y2: 43.409,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2FFCA1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01CEFD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "thor-logo_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h40v46H0z"
  })))));
};
export default SvgThorLogo;